module.exports = __webpack_public_path__ + "img/award-trophy-small.b4a75c1a.svg";